import React, { useEffect } from "react";

import background from "../assets/recurso_42.png";
import iso from "../assets/iso.png";

const ProcesoProductivo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <>
      <section
        id="quienes-somos"
        className="sector-hero relative bg-cover bg-no-repeat animate-fade-up"
        style={{
          backgroundImage: `url(${background})`,
          "--sector-bg-mobile": "36% center",
          "--sector-bg-desktop": "center center",
        }}
      >
        <div className="sector-hero-overlay grid grid-cols-1 bg-black bg-opacity-50">
          <div className="sector-content min-w-0 flex flex-col">
            <div className="flex flex-row justify-between items-center gap-3 border-r border-b border-white p-4 sm:p-6">
              <h1 className="max-w-[70%] text-white text-xs sm:text-lg leading-tight font-gotham font-light border border-white px-3 sm:pr-8 py-1 rounded-full uppercase" data-scroll-reveal>
                Proceso Productivo
              </h1>
              <div className="w-24 sm:w-40 shrink-0" data-scroll-reveal data-scroll-reveal-delay="80ms">
                <img src={iso} alt="iso" className="w-full" />
              </div>
            </div>
            <div className="flex flex-1 flex-col pt-10 sm:pt-16 px-5 sm:px-12 lg:px-20 pb-8 border-r border-b border-white mb-8 sm:mb-20 rounded-br-2xl sm:rounded-br-3xl" >
                <h2 className="max-w-full text-white text-4xl sm:text-6xl leading-[0.98] font-gotham font-medium break-words" data-scroll-reveal data-scroll-reveal-delay="90ms">STOCK DE MATERIAS PRIMAS</h2>
                <h3 className="text-white text-[15px] sm:text-xl font-gotham font-light mt-4 leading-relaxed" data-scroll-reveal data-scroll-reveal-delay="160ms">Contamos con stock de materia prima en diferentes tipos y gramajes.</h3>
                <ul className="mt-2" data-scroll-reveal data-scroll-reveal-delay="220ms">
                    <li className="text-white text-lg font-gotham font-light mt-1">• PAPEL BLANCO</li>
                    <li className="text-white text-lg font-gotham font-light mt-1">• PAPEL KRAFT</li>
                    <li className="text-white text-lg font-gotham font-light mt-1">• IMPORTADO</li>
                    <li className="text-white text-lg font-gotham font-light mt-1">• PAPEL NACIONAL</li>
                    <li className="text-white text-lg font-gotham font-light mt-1">• RECICLADO</li>
                </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProcesoProductivo;
